import React from "react";
import { createViewArray } from "../../templates/Templates";
import { aboutPageData, aboutPageBottomData, investors, team } from "./markup";
import UserImage from "../../components/UserImage/UserImage";
import "../About/team.css";

export default ({ location }) => {
  const views = createViewArray(aboutPageData, location);
  const bottomViews = createViewArray(aboutPageBottomData, location);
  return (
    <div>
      {views.map(view => {
        return view;
      })}
      <div className={"team white-background"}>
        <TeamView />
        <Investors />
      </div>
      {bottomViews.map(view => {
        return view;
      })}
    </div>
  );
};

const TeamView = () => {
  return (
    <div id="team" className={"team-members white-background"}>
      <h1 className={"large-title purple center-text"}>Our Team</h1>
      <div className={"member-list"}>
        {team.map((member, idx) => (
          <div key={member.name + idx} className={"member"}>
            <UserImage data={member} />
          </div>
        ))}
      </div>
      <div className={"contributor-names"}>
        <h1 className={"large-title purple"}>{investors.contributorTitle}</h1>
        {investors.pastContributors.map((contributor, idx) => (
          <p key={contributor + idx} className={"paragraph-text"}>
            {contributor}
          </p>
        ))}
      </div>
    </div>
  );
};

const Investors = () => {
  return (
    <div id="investors" className={"investor-list"}>
      <h1 className={"purple large-title"}>{investors.title}</h1>
      {investors.subtext.map((subtext, idx) => (
        <p
          key={subtext.text + idx}
          className={"subtext " + subtext.class || ""}
        >
          {subtext.text}
        </p>
      ))}
      <div className={"investor-names"}>
        {investors.investors.map((investor, idx) =>
          investor.name ? (
            <div key={investor.name + idx} className={"investor-extra"}>
              <p className={"paragraph-text"}>{investor.name}</p>
              <p className={"extra-sm-text italic"}>{investor.subName}</p>
            </div>
          ) : (
            <p key={investor + idx} className={"paragraph-text"}>
              {investor}
            </p>
          )
        )}
      </div>
    </div>
  );
};
